/*
 * @Description: 
 * @Author: Mayer
 * @Date: 2023-08-22 20:38:20
 * @LastEditors: Mayer
 * @LastEditTime: 2024-01-29 17:38:38
 */
import React from "react";
import ReactSimpleVerify from 'react-simple-verify'
import 'react-simple-verify/dist/react-simple-verify.css'
import './verify.less'
import intl from "react-intl-universal";

class Error extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      lp: 0,
      topc: 1
    }
  }
  componentDidMount() {
    let wd: any = document.body.clientWidth;
    if(wd>750){
      wd=750;
    }
    let wdlist = [0.66, 0.58, 0.64, 0.68, 0.62]
    let a = Math.floor(Math.random() * 4.99);
    let b: number = Math.floor(Math.random() * 4.99);

    let lpwd = wd * (wdlist[a]);
    this.setState({ lp: lpwd, topc: b });
  }
  success = () => {
    this.props.success();
  }
  close = () => {
    this.props.close();
  }
  render() {
    return (
      <div className="page_verify">
        <div className="cover" onClick={this.close.bind(this)}>
        </div>
        <div className={"verify verify" + this.state.topc}>
          {this.state.lp > 0 ?
            <ReactSimpleVerify
              // bgColor="#ebebeb"
              tips={intl.get('landing.name5')}
              successTips={intl.get('landing.name6')}
              movedColor={'#117ef2'}
              width={this.state.lp} ref="verify" success={this.success.bind(this)} /> : ""}
        </div>
      </div>
    );
  }
}

export default Error;
